import { jsx } from 'react/jsx-runtime';
import { Global, css } from '@emotion/core';
function _tagged_template_literal_loose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _templateObject() {
  var data = _tagged_template_literal_loose(["\n        ", "\n        ", "\n      "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var GlobalThemeStyle = param => {
  var {
    typography
  } = param;
  var {
    fontFace,
    fontFamily: customFontFamily,
    enableCustomFontGlobally = true
  } = typography || {};
  var {
    cssFontSource,
    customFontSource
  } = fontFace || {};
  var fontFaceDefinitionCssString = "";
  // remote font definition resource
  if (cssFontSource) {
    fontFaceDefinitionCssString += "@import url('" + cssFontSource + "');";
  }
  // font definition objects
  if (Array.isArray(customFontSource)) {
    fontFaceDefinitionCssString += customFontSource.filter(Boolean).map(param => {
      var {
        fontFamily,
        fontDisplay,
        fontStyle,
        fontWeight,
        src
      } = param;
      return "\n            @font-face {\n              " + (src ? "src: " + src + ";" : "") + "\n              " + (fontStyle ? "font-style: " + fontStyle + ";" : "") + "\n              " + (fontWeight ? "font-weight: " + fontWeight + ";" : "") + "\n              " + (fontFamily ? "font-family: " + fontFamily + ";" : "") + "\n              " + (fontDisplay ? "font-display: " + fontDisplay + ";" : "") + "\n            }\n          ";
    }).join("");
  }
  return /*#__PURE__*/jsx(Global, {
    styles: css(_templateObject(), fontFaceDefinitionCssString, customFontFamily && enableCustomFontGlobally ? "\n          body {\n            font-family: '" + customFontFamily + "';\n          }\n        " : "")
  });
};
export { GlobalThemeStyle as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsVGhlbWVTdHlsZS5qcyIsInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIifQ==
